import {get, post} from '@/axios';
// 获取省份一览
 export const getProvince = p => post('getAddress/getProvince', p);
// 获取城市一览
 export const getCity = p => post('getAddress/getCity', p);
// 获取区县一览
export const getArea = p => post('getAddress/getArea', p);
// 获取街道一览
export const getStreet = p => post('getAddress/getStreet', p);




// WEBPACK FOOTER //
// ./src/api/system/address.js